export const dlWayfindingZoomIn = (payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ...payload,
        event: 'Wayfinding Zoom In',
    });
};

export const dlWayfindingZoomOut = (payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ...payload,
        event: 'Wayfinding Zoom Out',
    });
};

export const dlWayfindingMapDrag = (payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ...payload,
        event: 'Wayfinding Map Drag',
    });
};

export const dlWayfindingMapPinch = (payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ...payload,
        event: 'Wayfinding Map Pinch',
    });
};

export const dlWayfindingMapReset = (payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ...payload,
        event: 'Wayfinding Map Reset',
    });
};